export enum IconColor {
  Default = 'default',
  Red = 'red',
  Green = 'green',
  Grey = 'grey',
  LightGrey = 'lightgrey',
  Yellow = 'yellow',
}
